import React, { useEffect } from 'react';
import Webcam from 'react-webcam';
import { useRef, useState, useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import * as tf from '@tensorflow/tfjs';
import '@tensorflow/tfjs-backend-webgl';
import * as facemesh from '@tensorflow-models/face-landmarks-detection';
import * as blazeface from '@tensorflow-models/blazeface';
import { AiFillCamera } from 'react-icons/ai';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function WebcamCaptureSelfie({
  circularWebCam,
  setOpenLoader,
  setCounter,
  setSelfieLoader,
  setSelfSelfieImgSrc,
  setPreviewImageSrc,
  setWebCamShowHide,
  setVisibleSelfie,
  fireFaceMatchApi
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const webcamRef = useRef(null);
  const cameraSoundRef = useRef();
  // const canvasRef2 = useRef(null);
  const canvasRef3 = useRef(null);
  // const [imgSrc, setImgSrc] = useState(null);
  const [mirrorValue, setMirrorValue] = useState(false);
  const [status, setStatus] = useState('face');
  const [mutategesture, setmutategesture] = useState(null);

  const [captureButtonShow, setCaptureButtonShow] = useState(false);

  // loaded models
  const [modelsLoaded, setModelsLoaded] = useState(true);

  // const [refreshCompcamera, setRefreshCompcamera] = useState(null);

  const EAR_THRESHOLD = 0.15;
  // const emotions = ['angry', 'disgust', 'fear', 'happy', 'neutral', 'sad', 'surprise'];

  let control1 = false;
  let control2 = false;
  let control3 = false;

  const runFacemesh = async () => {
    console.log('circularWebCam 3', circularWebCam);
    setSelfieLoader && setSelfieLoader(true);
    console.log('circularWebCam 3-1', circularWebCam);

    const BoxCanvasOverlay = document.getElementById('BoxCanvasOverlay'); // BoxCanvasOverlay
    const ctxBoxCanvasOverlay = BoxCanvasOverlay.getContext('2d');
    const tempCanvas = document.getElementById('tempCanvas');
    const tempContext = tempCanvas.getContext('2d');

    const canvas = document.getElementById('canvas3');
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    console.log('circularWebCam 3-2', circularWebCam);
    setSelfieLoader && setSelfieLoader(true);

    const net = await facemesh.load(facemesh.SupportedPackages.mediapipeFacemesh, { maxFaces: 1 });
    setSelfieLoader && setSelfieLoader(true);
    console.log('circularWebCam 4', net); // don't remove the console otherwise, camera ovell will not load proper
    const modelLandMark = await blazeface.load();
    console.log('circularWebCam 5', modelLandMark); // don't remove the console otherwise, camera ovell will not load proper
    setSelfieLoader && setSelfieLoader(true);

    // emotionModel = await tf.loadLayersModel(`${BASE_URL}/web/model/facemo.json`);

    // load model for face detection emotions models
    const MODEL_URL = process.env.PUBLIC_URL + '/models';
    setSelfieLoader && setSelfieLoader(true);
    console.log('circularWebCam 5', MODEL_URL);

    Promise.all([
      window.faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
      window.faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
      window.faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      window.faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL)
    ]).then(setModelsLoaded(true));
    setSelfieLoader && setSelfieLoader(true);

    if (webcamRef.current && canvasRef3.current) {
      console.log('circularWebCam 4-2', net);
      setSelfieLoader && setSelfieLoader(false); // false when comes boxOverlay

      const videoWidth = webcamRef.current.video.clientWidth;
      const videoHeight = webcamRef.current.video.clientHeight;
      canvasRef3.current.width = videoWidth;
      canvasRef3.current.height = videoHeight;

      BoxCanvasOverlay.width = videoWidth;
      BoxCanvasOverlay.height = videoHeight;

      tempCanvas.width = videoWidth;
      tempCanvas.height = videoHeight;

      // properties

      const x0 = Number(videoWidth / 2);
      const y0 = Number(videoHeight / 2);
      const r0 = 100;
      const x1 = Number(videoWidth / 2);
      const y1 = Number(videoHeight / 2);
      const r1 = 130;

      // Overlay code
      ctxBoxCanvasOverlay.translate(0, 0);

      tempContext.save();

      // clear temp context
      tempContext.clearRect(0, 0, canvas.width, canvas.height);

      // draw rectangle (destination)
      tempContext.beginPath();
      tempContext.rect(0, 0, canvas.width, canvas.height);
      tempContext.fillStyle = 'rgba(0,0,0,0.6)';
      tempContext.fill();

      // set global composite
      tempContext.globalCompositeOperation = 'destination-out';

      // draw circle (source)
      tempContext.beginPath();
      tempContext.ellipse(
        x0,
        y0,
        Number(videoWidth) - Number(videoHeight) > 100 ? y0 - 90 : y0 - 70,
        y0 - 20,
        0,
        0,
        2 * Math.PI,
        false
      );
      tempContext.fillStyle = 'red';
      tempContext.fill();
      tempContext.restore();

      // translate visible context so operation is drawn in the right place
      ctxBoxCanvasOverlay.translate(0, 0);

      // copy drawing from tempCanvas onto visible canvas
      ctxBoxCanvasOverlay.drawImage(tempCanvas, 0, 0);

      ctx.beginPath();
      ctx.ellipse(
        x0,
        y0,
        Number(videoWidth) - Number(videoHeight) > 100 ? y0 - 90 : y0 - 70,
        y0 - 20,
        0,
        0,
        2 * Math.PI,
        false
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'rgb(124,252,0)';
      ctx.stroke();
    }

    setInterval(() => {
      console.log('circularWebCam 4-3', net);
      detect(net, modelLandMark);
    }, 500);
  };

  function getEAR(upper, lower) {
    function getEucledianDistance(x1, y1, x2, y2) {
      return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }

    return (
      (getEucledianDistance(upper[5][0], upper[5][1], lower[4][0], lower[4][1]) +
        getEucledianDistance(upper[3][0], upper[3][1], lower[2][0], lower[2][1])) /
      (2 * getEucledianDistance(upper[0][0], upper[0][1], upper[8][0], upper[8][1]))
    );
  }

  const detect = async (net, modelLandMark) => {
    if (
      typeof webcamRef.current !== 'undefined' &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) {
      // const canvas2 = document.getElementById('canvas2');
      // const ctx2 = canvas2.getContext('2d');
      // Get Video Properties
      const video = webcamRef.current.video;
      const displaySize = {
        width: webcamRef.current.video.clientWidth,
        height: webcamRef.current.video.clientHeight
      };
      // canvas2.width = webcamRef.current.video.clientWidth;
      // canvas2.height = webcamRef.current.video.clientHeight;

      const face = await net.estimateFaces({
        input: video,
        returnTensors: false,
        flipHorizontal: false
      });

      const predictionLandmarks = await modelLandMark.estimateFaces(video, false);

      // const resizedDetections = window.faceapi.resizeResults(predictionLandmarks, displaySize);

      if (face.length > 0 && predictionLandmarks.length > 0) {
        // setLoader && setLoader(false);

        let prediction = face[0];
        if (!control1 || (control1 && !control2) || (control1 && control2 && !control3)) {
          setSelfieLoader && setSelfieLoader(false);
        }

        if (
          predictionLandmarks[0].landmarks[4][0] > predictionLandmarks[0].landmarks[0][0] + 30 &&
          !control1 &&
          circularWebCam === 'webcamstyle' &&
          prediction.faceInViewConfidence != 1
        ) {
          setmutategesture(new Date());
          setSelfieLoader && setSelfieLoader(true);
          control1 = true;

          cameraSoundRef.current.play();
          // setRefreshCompcamera(new Date());
        } else if (prediction.faceInViewConfidence == 1 && control1 && !control2 && !control3) {
          const faceapi = window.faceapi;

          const detections = await faceapi
            .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
            .withFaceLandmarks()
            .withFaceExpressions();
          setStatus('smile');

          if (detections.length > 0) {
            if (detections[0].expressions.happy >= 0.95 && detections[0].expressions.neutral < 1) {
              setSelfieLoader && setSelfieLoader(true);
              control2 = true;
              // capture('smile');
              setmutategesture(new Date());
            }
          }
        } else if (control1 && control2 && !control3) {
          setmutategesture(new Date());
          setStatus('eye');
          const lowerRight = prediction.annotations.rightEyeUpper0;
          const upperRight = prediction.annotations.rightEyeLower0;
          const rightEAR = getEAR(upperRight, lowerRight);
          // Left eye parameters
          const lowerLeft = prediction.annotations.leftEyeUpper0;
          const upperLeft = prediction.annotations.leftEyeLower0;
          const leftEAR = getEAR(upperLeft, lowerLeft);

          // True if the eye is closed
          const blinked = leftEAR <= EAR_THRESHOLD && rightEAR <= EAR_THRESHOLD;
          // Determine how long you blinked
          if (blinked) {
            setStatus('done');
            control3 = true;
            setTimeout(() => {
              capture('blink');
            }, 1000);
            cameraSoundRef.current.play();
            setCounter && setCounter(true);
            setOpenLoader && setOpenLoader(true);
            setSelfieLoader && setSelfieLoader(false);
            setTimeout(() => {
              capture('CounterCapture');
            }, [3000]);
          } else {
          }
        }
      } else {
        setCaptureButtonShow(false);
      }
    }
  };

  const convertBase64ToFile = (dataurl) => {
    try {
      //Convert base64 to file image
      let arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];

      const fileFormat = mime.replace('/', ' ');

      const mimeArray = fileFormat.split(' ');

      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let newFile = new File([u8arr], `${'selfi'}.${mimeArray[1]}`, {
        type: mime
      });
      return newFile;
    } catch (error) {
      console.error('Error converting base64 to file:', error);
    }
  };

  const capture = useCallback(
    (action) => {
      setSelfieLoader && setSelfieLoader(true);

      const imageSrc = webcamRef.current.getScreenshot();

      const binaryFile = convertBase64ToFile(imageSrc);

      // fire watermark api with docuemntselfi
      // if (navigateTo === 'documentselfie') {
      //   const fireUploadImageWaterMarkForDocumentSelfiApi = async () => {
      //     // send data to back to document
      //     setDocumentImgSrc && setDocumentImgSrc(imageSrc);

      //     if (setSelfieImgSrc !== undefined) {
      //       uploadImage(binaryFile);
      //       setSelfieImgSrc(imageSrc);
      //     }
      //   };
      //   fireUploadImageWaterMarkForDocumentSelfiApi();
      // }

      if (circularWebCam === 'webcamstyle') {
        // console.log('fireFaceMatchApi', action);
        setSelfSelfieImgSrc(imageSrc);
        setPreviewImageSrc(imageSrc);
        if (action === 'smile') {
        }
        if (action === 'blink') {
          setSelfieLoader && setSelfieLoader(false);
        } else if (action == 'CounterCapture') {
          // console.log('fireFaceMatchApi', 'CounterCapture');
          // GetFileFromUrlApi(); // GetfileFromURLApi to get docSelfie pic
          setTimeout(() => {
            fireFaceMatchApi(binaryFile);
          }, 2000);

          /// first face match
          // const getPersonalData = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75-ocr');
          // console.log('fireFaceMatchApi', getPersonalData);
          // if (getPersonalData) {
          //   console.log('fireFaceMatchApi', getPersonalData);
          //   const getPersonalDetails = CryptoJS.AES.decrypt(getPersonalData, 'ocrData');

          //   const getPersonalDetails123 = getPersonalDetails.toString(CryptoJS.enc.Utf8);

          //   const OriginalPersonalData = JSON.parse(getPersonalDetails123);
          //   setOriginalPersonalDetails(OriginalPersonalData);

          //   // const GetFileFromUrlApi = () => {
          //   //   const credential = {
          //   //     organizationId: 1,
          //   //     fileUrl: OriginalPersonalData.doc_url
          //   //   };

          //   //   fetch(`${globalSRP}/getFileFromUrl`, {
          //   //     method: 'GET',
          //   //     headers: {
          //   //       ...credential
          //   //     }
          //   //   })
          //   //     .then((res) => res.blob())
          //   //     .then((blob) => {
          //   //       const reader = new FileReader();
          //   //       reader.onloadend = () => {
          //   //         const docBinaryFile = convertBase64ToFile(reader.result);

          //   //         setGetFileFromUrlApiResponse(docBinaryFile);
          //   //         setTimeout(() => {
          //   //           console.log('fireFaceMatchApi');
          //   //           fireFaceMatchApi(binaryFile, docBinaryFile);
          //   //         }, 3000);
          //   //       };
          //   //       reader.readAsDataURL(blob);
          //   //     });
          //   // };
          //   // GetFileFromUrlApi();
          // }

          setSelfieLoader && setSelfieLoader(true);

          navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then((mediaStream) => {
            const tracks = mediaStream.getTracks();
            tracks[0].stop();
          });

          // set preview image and navigate
          setPreviewImageSrc(imageSrc);

          setSelfieLoader && setSelfieLoader(false);

          setWebCamShowHide(true);
          setVisibleSelfie(false);
          // navigate('/in/face-selfie-preview');
        }
      } else {
      }
    },
    [webcamRef, setPreviewImageSrc]
  );

  useEffect(() => {
    // setSelfieLoader && setSelfieLoader(true);
    const isSafari = window.safari !== undefined;
    const userAgent = window.navigator.userAgent;

    if (isSafari || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      setMirrorValue(true);
      // return false;
    } else {
      setMirrorValue(false);
    }
    // by default mirror value is false

    // const GetStartUpConfigApi = async () => {
    //   const GetStartUpConfigResponse = await GetStartUpConfig();
    //   if (GetStartUpConfigResponse.status === 'Success') {
    //     setGetStartUpConfigResponse(GetStartUpConfigResponse.data);
    //   }
    // };
    // GetStartUpConfigApi();

    // checkLocation(setOpenValidation, setValidationMsg, setPermission, t);

    if (cameraSoundRef.current) {
      if (cameraSoundRef.current.video) {
        cameraSoundRef.current.video = undefined;
      }
    }
    if (circularWebCam) {
      runFacemesh();
    }
    // setTimeout(() => {
    //   setSelfieLoader && setSelfieLoader(false);
    // }, 2000);

    window.addEventListener('resize', () => {
      if (circularWebCam) {
        runFacemesh();
      }
    });
    return () => {
      window.removeEventListener('resize', () => {
        if (circularWebCam) {
          runFacemesh();
        }
      });
    };
  }, []);

  return (
    <Box sx={{ textAlign: 'center', position: 'relative' }}>
      <Box className="cameraSound" style={{ opacity: 0, position: 'absolute' }}>
        <audio controls ref={cameraSoundRef}>
          <source src={`/assets/mixkit-camera-lens-shutter-1433.wav`} type="audio/wav" />
          Your browser does not support the audio element.
        </audio>
      </Box>

      <>
        {/* <Box className={circularWebCam ? 'webcamContainer' : ''}> */}
        <Box className="webcamContainer">
          {/* <Validation
            openValidation={openValidation}
            validationMsg={validationMsg}
            handleClose={handleCloseVal}
            ocrData
            setOpenValidation={setOpenValidation}
            setDisableButton={setDisableButton}
          /> */}
          <Webcam
            audio={false}
            ref={webcamRef}
            mirrored={mirrorValue}
            screenshotFormat="image/jpeg"
            style={{ zIndex: -1, width: '100%', maxWidth: 640 }}
            className={
              // circularWebCam ? circularWebCam : documentSelfiClassName ? documentSelfiClassName : ''
              circularWebCam ? circularWebCam : ''
            }
            onUserMediaError={(e) => {
              navigate('/in/face-selfie');
            }}
          />
          <canvas id="BoxCanvasOverlay" className="docSelfieCameraOpenRad" />
          <canvas id="tempCanvas" style={{ display: 'none' }} className="docSelfieCameraOpenRad" />
          <canvas
            id="canvas3"
            ref={canvasRef3}
            style={{ display: 'none' }}
            className="docSelfieCameraOpenRad"
          />
          {/* <canvas id="canvas2" ref={canvasRef2} className="docSelfieCameraOpenCv" /> */}
        </Box>
        <Box>
          <Typography variant="subtitle1" className="selfieInst">
            {!control1 && status === 'face'
              ? t('Please face to the right')
              : !control2 && status === 'smile'
              ? t('Please face straight and smile')
              : !control3 && status === 'eye'
              ? t('Blink and stand still')
              : ''}
          </Typography>

          <GestureOne
            control1={control1}
            control2={control2}
            control3={control3}
            status={status}
            mutategesture={mutategesture}
            // BASE_URL={BASE_URL}
          />
        </Box>
      </>
    </Box>
  );
}

export default WebcamCaptureSelfie;

function GestureOne({ mutategesture, control1, status, control2, BASE_URL, control3 }) {
  useEffect(() => {}, [mutategesture]);
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
        marginTop: 10
      }}
      className="selfieIconsOuter"
    >
      {/*  pic one with arrow */}
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className="selfieIconsBox"
      >
        <img
          src={
            !control1 && status === 'face'
              ? `/static/camera/side_face.svg`
              : status === 'smile' || status === 'eye' || status === 'done'
              ? `/static/camera/side_face_green.svg`
              : `/static/camera/side_face.svg`
          }
          alt=""
          className="selfieIcon"
          style={{
            marginRight: '0.5rem'
          }}
        />
        <img
          src={
            !control1 && status === 'face'
              ? `/static/camera/arrow_right.svg`
              : status === 'smile' || status === 'eye' || status === 'done'
              ? `/static/camera/arrow_right_green.svg`
              : `/static/camera/arrow_right.svg`
          }
          alt=""
          className="arrowIcon"
        />
      </Box>

      {/* pic two with arrow */}
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className="selfieIconsBox"
      >
        <img
          src={
            !control2 && status === 'smile'
              ? `/static/camera/smile_face.svg`
              : status === 'eye' || status === 'done'
              ? `/static/camera/smile_face_green.svg`
              : `/static/camera/smile_face.svg`
          }
          alt=""
          className="selfieIcon"
          style={{
            marginRight: '0.5rem'
          }}
        />
        <img
          src={
            !control2 && status === 'smile'
              ? `/static/camera/arrow_right.svg`
              : status === 'eye' || status === 'done'
              ? `/static/camera/arrow_right_green.svg`
              : `/static/camera/arrow_right.svg`
          }
          alt=""
          className="arrowIcon"
        />
      </Box>

      {/*  pic 3   */}
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className="selfieIconsBox"
      >
        <img
          src={
            !control3 && status == 'eye'
              ? `/static/camera/blink_eye_face.svg`
              : status == 'done'
              ? `/static/camera/blink_eye_face_green.svg`
              : `/static/camera/blink_eye_face.svg`
          }
          alt=""
          className="selfieIcon"
        />
      </Box>
    </Box>
  );
}
